import { subDays } from 'date-fns';
import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

/**
 * Given the calendar day a period ends, return the calendar day it began.
 * An overnight window started on the prior day; all other windows started on the same day.
 * Example: end May 6 → start May 5 (overnight) or start May 6 (hours/all-day).
 */
export function getDailyPeriodStartFromEndDay(
  endDay: Date,
  timeIntervalType: TimeIntervalTypeValues
): Date {
  if (timeIntervalType === TimeIntervalTypeValues.OVERNIGHT) {
    return subDays(endDay, 1);
  }

  return endDay;
}
